import { ConsentData } from '../reducers/consent/types';

export enum FlowType {
  consent = 'consent',
  static = 'static',
  confirm = 'confirm',
}
export type GetConsentResponse = ConsentData;
